/**
 * Resolves the UI result type from the backend `confirmation_summary` object.
 *
 * Three possible states:
 *   AUTO_APPROVED         – verified sale with no open observation
 *   PRE_APPROVED          – sale requires manual review (approval_status === 'pre_approved')
 *   APPROVED_WITH_OBS     – sale approved but an observation is open (observation_status === 'open')
 */
export const RESULT_TYPES = {
  AUTO_APPROVED:       'auto_approved',
  PRE_APPROVED:        'pre_approved',
  APPROVED_WITH_OBS:   'approved_with_observation',
};

export const getSaleResultType = (confirmationSummary) => {
  if (!confirmationSummary || typeof confirmationSummary !== 'object') {
    return RESULT_TYPES.AUTO_APPROVED;
  }

  const { approval_status, observation_status } = confirmationSummary;

  if (approval_status === 'pre_approved') {
    return RESULT_TYPES.PRE_APPROVED;
  }

  if (observation_status === 'open') {
    return RESULT_TYPES.APPROVED_WITH_OBS;
  }

  return RESULT_TYPES.AUTO_APPROVED;
};
